import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './ViewMode.module.css';
import {  useCCContext } from '../CC/CCContext';

function ViewMode() {
  const { cc, setCc, viewMode, setViewMode } = useCCContext();
  
  const changeModeToIcons = () => {
    setViewMode('icons');
    setCc(cc);
  }
  
  const changeModeToList = () => {
    setViewMode('list');
    setCc(cc);
  }
  return (
    <div className={styles.ViewMode}>
      <GenericIconButton ariaLabel='Vue en grille' isActive={viewMode === 'icons'} icon='light/th.svg' onClick={ () => changeModeToIcons() }/>
      <GenericIconButton ariaLabel='Vue en liste' isActive={viewMode === 'list'} icon='light/list.svg' onClick={ () => changeModeToList() }/>
    </div>
  );
}

export default ViewMode;
